import { render } from "./MaterialSelectedBadge.vue?vue&type=template&id=5531a823&scoped=true"
import script from "./MaterialSelectedBadge.vue?vue&type=script&lang=js"
export * from "./MaterialSelectedBadge.vue?vue&type=script&lang=js"

import "./MaterialSelectedBadge.vue?vue&type=style&index=0&id=5531a823&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5531a823"]])

export default __exports__